const TermsAndConditions = () => {
  return (
    <>
      <ol>
        <li>
          <p>Úvod a základní ustanovení</p>
          <ol type="a">
            <li>
              <p>
                „Poskytovatel“: Obchodní společnost Stosuj s.r.o., IČO: 143 99 831, se sídlem: Kaprova 42/14, Staré Město, 110 00 Praha, zapsaná v obchodním rejstříku vedeném u Městského soudu v Praze, oddíl C, vložka 364569.
              </p>
            </li>
            <li>
              <p>
                „Služba“: Webová aplikace provozovaná na doméně stosuj.cz (dále jen „Aplikace“), která slouží jako softwarový nástroj (SaaS) pro automatizaci uživatelských procesů.
              </p>
            </li>
            <li>
              <p>
                „Povaha služby“: Služba je poskytována <strong>výhradně jako pronájem softwarového nástroje</strong>. Poskytovatel není v rámci této Služby poskytovatelem investičních služeb, obchodníkem s cennými papíry nebo poskytovatelem služeb souvisejících s kryptoaktivy, ani neposkytuje investiční poradenství.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel v rámci Služby nevykonává zejména správu portfolia Klienta, neposkytuje individualizovaná doporučení, nezajišťuje „best execution“, neurčuje vhodnost Strategie a není smluvní stranou obchodů uzavíraných mezi Klientem a Podporovanou platformou nebo jakoukoliv třetí stranou.
              </p>
            </li>
            <li>
              <p>
                „Klient“: Fyzická nebo právnická osoba, která se zaregistruje v Aplikaci a odsouhlasí tyto Podmínky.
              </p>
            </li>
            <li>
              <p>
                „Spotřebitel“: Klient, který je fyzickou osobou a při uzavírání smlouvy nejedná v rámci své podnikatelské činnosti nebo v rámci samostatného výkonu svého povolání.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Definice pojmů</p>
          <ol type="a">
            <li>
              <p>
                „Podporovaná platforma“: Externí subjekt, poskytovatel služeb souvisejících s kryptoaktivy ve smyslu nařízení MiCA [Nařízení Evropského parlamentu a Rady (EU) 2023/1114 ze dne 31. května 2023 o trzích kryptoaktiv a o změně nařízení (EU) č. 1093/2010 a (EU) č. 1095/2010 a směrnic 2013/36/EU a (EU) 2019/1937], poskytující zejména služby směny kryptoaktiv za peněžní prostředky nebo jiná kryptoaktiva, přijímání a předávání pokynů ke kryptoaktivům, provádění pokynů ke kryptoaktivům nebo provozování obchodní platformy pro kryptoaktiva, který umožňuje technické propojení prostřednictvím API a kterého Aplikace technicky integruje (např. Coinmate, Anycoin a další).
              </p>
            </li>
            <li>
              <p>
                „API klíč“: Unikátní softwarový identifikátor Klienta generovaný Podporovanou platformou, který umožňuje Klientovi zasílat automatizované datové požadavky na účet Klienta u Podporované platformy v rozsahu oprávnění nastavených Klientem.
              </p>
            </li>
            <li>
              <p>
                „Štosáky“ (Kredity): Interní zúčtovací jednotka Aplikace sloužící k úhradě měsíčního předplatného za služby (tarify). Nejedná se o elektronické peníze ani kryptoaktivum.
              </p>
            </li>
            <li>
              <p>
                „Cashback saty“ (Věrnostní body): Virtuální body ve věrnostním programu. Ačkoliv se jejich hodnota může marketingově odvozovat od kurzu BTC/CZK, nejedná se o reálný bitcoin a nelze je vybrat do peněženky.
              </p>
            </li>
            <li>
              <p>
                „Strategie“: Parametry nastavené Klientem (např. čas, částka a další), na základě kterých Aplikace generuje technické datové zprávy (Webhook) Klientovi.
              </p>
            </li>
            <li>
              <p>
                „Webhook“: Automatizovaná datová zpráva, kterou Aplikace odešle do dispozice Klienta v okamžiku, kdy vyhodnotí, že nastala Klientem nastavená podmínka Strategie.
              </p>
            </li>
            <li>
              <p>
                „Whitelist“: Bezpečnostní funkce na straně Podporované platformy, omezující výběry bitcoinu pouze na předem schválené adresy.
              </p>
            </li>
            <li>
              <p>
                „Uživatelský účet“: Účet Klienta v Aplikaci, prostřednictvím kterého Klient spravuje nastavení Služby, Strategie, API propojení, předplatné a další funkce Aplikace.
              </p>
            </li>
            <li>
              <p>
                „Kontejner“: Samostatná výpočetní jednotka v cloudové infrastruktuře (AWS) Poskytovatele, kterou si Klient může pronajmout k automatizovanému zpracování Webhooku a odeslání autorizovaného požadavku na Podporovanou platformu.
              </p>
            </li>
            <li>
              <p>
                „Forward proxy“: Technická komponenta Poskytovatele, která Klientem autorizované požadavky vzniklé zpracováním Webhooku, ať na vlastním hostingu Klienta nebo v pronajatém Kontejneru, beze změny předává na Podporovanou platformu, a to z důvodu bezpečnostního technického omezení přístupu na straně Podporované platformy podle IP adresy.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Předmět služby a technické fungování</p>
          <ol type="a">
            <li>
              <p>
                Aplikace funguje jako technický softwarový automatizovaný nástroj Klienta. Na základě parametrů Strategie zadaných v Aplikaci výhradně Klientem odesílá Klient prostřednictvím rozhraní API technické datové požadavky na server Podporované platformy. Aplikace sleduje tržní data a při naplnění Klientem nastavené podmínky odešle Webhook do dispozice Klienta, na jehož základě je vytvořen a Klientem odeslán příslušný technický požadavek na server Podporované platformy. Základní architektura je popsána na stránce <a href="/technicke-reseni">Technické řešení</a>.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel nevstupuje do rozhodování Klienta o tom, zda, kdy a v jakém rozsahu má Klient kryptoaktiva nakupovat, prodávat nebo převádět. Poskytovatel neposuzuje vhodnost Strategie ani nepřebírá odpovědnost za její ekonomický výsledek. Poskytovatel pouze zajišťuje technickou dostupnost infrastruktury (SaaS).
              </p>
            </li>
            <li>
              <p>
                Poskytovatel <strong>nikdy nepřijímá, nedrží, nespravuje ani nekontroluje peněžní prostředky ani kryptoaktiva Klienta</strong>. Veškeré operace probíhají v rámci smluvního vztahu Klienta a Podporované platformy, přímo na účtu Klienta u Podporované platformy a podle pravidel této Podporované platformy.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel není smluvní stranou ani zprostředkovatelem obchodů realizovaných Klientem na Podporované platformě, nestanovuje cenu ani nevybírá protistranu obchodu, neprovádí předávání ani párování obchodních příkazů, nemá vliv na provedení obchodů Podporovanou platformou a neodpovídá za způsob zpracování požadavků Podporovanou platformou.
              </p>
            </li>
            <li>
              <p>
                Zpracování objednávek Klienta, případně použitý typ objednávky na Podporované platformě a s tím spojené poplatky se mohou lišit v závislosti na typu prováděné objednávky v rámci Strategie, pravidlech Podporované platformy a na aktuálně aktivním předplatném Klienta. Veškeré podrobnosti o mechanismech a poplatcích jsou popsány na stránce <a href="/prehled-poplatku">Přehled poplatků</a>.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel je oprávněn měnit, omezit, pozastavit nebo ukončit podporu konkrétních funkcí, Strategií, API integrací či Podporovaných platforem, zejména z technických, bezpečnostních, smluvních nebo regulatorních důvodů. V případě, že dojde na straně Poskytovatele ke změnám, omezením, pozastavení nebo ukončení podpory dle věty první tohoto odstavce, tyto změny nemají vliv na smluvní vztah mezi Klientem a Podporovanou platformou.
              </p>
            </li>
            <li>
              <p>
                Pokud by některá funkce Aplikace vyžadovala odlišný právní či smluvní režim, může být nabízena pouze na základě samostatných podmínek nebo nemusí být v určitých zemích/segmentech Klientů zpřístupněna.
              </p>
            </li>
            <li>
              <p>
                Zpracování Webhooku Klientem může probíhat (i) na vlastním hostingu Klienta, kde Klient sám provozuje příslušné technické prostředky, případně si Webhook pouze přesměruje na e-mail nebo jinou notifikační službu a jedná na jeho základě manuálně, nebo (ii) v Kontejneru, který si Klient pronajme v cloudové infrastruktuře (AWS) Poskytovatele.
              </p>
            </li>
            <li>
              <p>
                Pronájem Kontejneru je dobrovolnou volbou Klienta. Poskytovatel aktuálně za pronájem Kontejneru neúčtuje žádné poplatky nad rámec zvolené verze předplatného, není-li v ceníku Poskytovatele stanoveno jinak. API klíč uložený v Kontejneru zůstává i nadále přístupovým prostředkem Klienta k jeho vlastnímu účtu u Podporované platformy, prostřednictvím kterého Klient autorizuje své pokyny vůči Podporované platformě.
              </p>
            </li>
            <li>
              <p>
                Pokud Klient odstraní propojení Aplikace s Podporovanou platformou nebo zcela zruší svůj Uživatelský účet, Poskytovatel příslušný Kontejner odstraní, včetně veškerých v něm uložených dat a API klíče.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Podmínky užívání a API propojení</p>
          <ol type="a">
            <li>
              <p>
                Pro využívání Služby musí mít Klient zřízený vlastní účet u Podporované platformy a splnit podmínky této Podporované platformy (včetně veškerých regulatorních požadavků).
              </p>
            </li>
            <li>
              <p>
                Klient nese plnou odpovědnost za správnost nastavení svého účtu u Podporované platformy, včetně nastavení API oprávnění, bezpečnostních prvků, limitů, Whitelistu, notifikací a dalších ochranných mechanismů dostupných na straně Podporované platformy.
              </p>
            </li>
            <li>
              <p>
                Klient používá API klíče v Aplikaci na vlastní odpovědnost a zavazuje se nastavit oprávnění API klíčů pouze na nezbytné minimum dle návodu v Aplikaci. Klient nesmí Poskytovateli poskytnout přístupové údaje v rozsahu, který není nutný pro zamýšlené používání Služby.
              </p>
            </li>
            <li>
              <p>
                Pokud Aplikace technicky podporuje funkci automatického výběru BTC na vlastní peněženku, smí Klient na API klíči povolit oprávnění k výběru výhradně tehdy, má-li na Podporované platformě aktivní Whitelist a v něm uvedenou pouze svou vlastní adresu peněženky.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel může funkci automatického výběru BTC kdykoliv omezit, podmínit dalším potvrzením Klienta, dočasně pozastavit nebo zcela deaktivovat, zejména z bezpečnostních, technických nebo regulatorních důvodů.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel nenese odpovědnost za ztrátu prostředků způsobenou zneužitím API klíče s povolenými výběry, zejména pokud Klient neměl řádně nastavenou funkci Whitelist nebo porušil bezpečnostní doporučení Podporované platformy či Poskytovatele.
              </p>
            </li>
            <li>
              <p>
                Klient nesmí Službu používat způsobem, který porušuje právní předpisy, práva třetích osob, podmínky Podporované platformy nebo bezpečnostní pravidla Aplikace.
              </p>
            </li>
            <li>
              <p>
                Klient bere na vědomí, že z důvodu technického omezení přístupu na straně Podporované platformy podle IP adresy (tzv. whitelist IP adres) jsou autorizované požadavky vytvořené Klientem na základě API klíče Klienta odesílány na Podporovanou platformu prostřednictvím Forward proxy Poskytovatele, a to bez ohledu na to, zda ke zpracování Webhooku dochází na vlastním hostingu Klienta nebo v pronajatém Kontejneru.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Uživatelský účet, zabezpečení a komunikace</p>
          <ol type="a">
            <li>
              <p>
                Klient je povinen chránit přístupové údaje ke svému Uživatelskému účtu v Aplikaci i k účtu u Podporované platformy, zejména používat dostatečně silné heslo a dostupné vícefaktorové ověření.
              </p>
            </li>
            <li>
              <p>
                Klient odpovídá za veškeré úkony provedené z jeho Uživatelského účtu, pokud neprokáže, že došlo k neoprávněnému přístupu bez jeho zavinění a bez porušení jeho bezpečnostních povinností.
              </p>
            </li>
            <li>
              <p>
                Klient je povinen bez zbytečného odkladu oznámit Poskytovateli podezření na zneužití účtu, API klíčů nebo bezpečnostní incident prostřednictvím kontaktních údajů uvedených v těchto Podmínkách.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel je oprávněn v odůvodněných případech (zejména při bezpečnostním incidentu, podezření na zneužití nebo porušení Podmínek) dočasně omezit funkčnost Uživatelského účtu nebo vyžadovat dodatečné ověření.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Štosáky, předplatné a platební podmínky</p>
          <ol type="a">
            <li>
              <p>
                Služby Aplikace (např. předplatné PREMIUM a PRO) jsou hrazeny prostřednictvím interních kreditů zvaných „Štosáky“. Nejedná se o elektronické peníze ani kryptoaktivum.
              </p>
            </li>
            <li>
              <p>
                Zakoupením Štosáků (jednorázovým balíčkem nebo formou pravidelné měsíční platby) si Klient kupuje časově neomezené kredity k užívání funkcí Aplikace dle aktuální nabídky. Štosáky nejsou vratné, nelze je směnit zpět na peníze a nelze je převést na jinou osobu, není-li výslovně uvedeno jinak.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel je oprávněn měnit ceník, strukturu tarifů, spotřebu kreditů a dostupnost funkcí. Tím nejsou dotčena již připsaná množství Štosáků, s výjimkou případů stanovených zákonem a těmito Podmínkami.
              </p>
            </li>
            <li>
              <p>
                Platby kartou: Jednorázové balíčky Štosáků a pravidelné měsíční platby za Štosáky kartou jsou zpracovávány platební bránou Stripe. V případě opakovaných plateb Klient souhlasí s opakovaným strháváním platby z karty (recurring payment). Opakované platby lze zpravidla kdykoliv zrušit v nastavení Aplikace nebo prostřednictvím odkazu v e-mailu s potvrzením platby.
              </p>
            </li>
            <li>
              <p>
                Platby bankovním převodem: Jednorázové balíčky Štosáků lze uhradit bankovním převodem a jsou zpracovávány platební bránou ThePay.
              </p>
            </li>
            <li>
              <p>
                Platby bitcoinem: Jednorázové balíčky Štosáků lze uhradit kryptoaktivem (bitcoinem) přes platební bránu OpenNode. Klient bere na vědomí, že jde výhradně o způsob úhrady za poskytnutí softwarové služby, přičemž fakturace probíhá v zákonné měně (CZK). Tato transakce představuje běžnou úhradu za zboží/službu, nikoliv investiční službu, službu související s kryptoaktivy nebo obchodování s kryptoaktivy ze strany Poskytovatele.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel nenese odpovědnost za nedokončení nebo zpoždění platby způsobené platební bránou, bankou, blockchainovou sítí, nesprávně zadanými údaji Klienta nebo jinou třetí stranou.
              </p>
            </li>
            <li>
              <p>
                Daňové doklady (faktury) jsou Klientovi zpřístupněny elektronicky v Aplikaci na stránce Štosáky.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Spotřebitelské informace, digitální služba a odstoupení od smlouvy</p>
          <ol type="a">
            <li>
              <p>
                Vyloučení odstoupení: Klient souhlasí, že digitální služba (připsání Štosáků/aktivace předplatného) je poskytnuta okamžitě po zaplacení. Tímto Klient ztrácí právo na odstoupení od smlouvy ve lhůtě 14 dnů.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Věrnostní program (Cashback saty)</p>
          <ol type="a">
            <li>
              <p>
                Klienti mohou získávat odměny ve formě „Cashback satů“. Jedná se o interní věrnostní body, nikoliv o kryptoaktivum (bitcoin).
              </p>
            </li>
            <li>
              <p>
                Cashback saty nelze vybrat do kryptoměnové peněženky ani směnit za peníze. Lze je využít pouze způsoby uvedenými v Aplikaci (např. konverzí na Štosáky) nebo darováním Poskytovateli na rozvoj Aplikace a marketing.
              </p>
            </li>
            <li>
              <p>
                Na připsání Cashback satů není právní nárok. Poskytovatel může věrnostní program kdykoliv změnit, pozastavit nebo ukončit; změny se nedotknou již řádně připsaných bodů v rozsahu, který vyžadují právní předpisy.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Rizika a odpovědnost</p>
          <ol type="a">
            <li>
              <p>
                Klient bere na vědomí, že trh s kryptoaktivy je volatilní a že jakékoliv obchody s kryptoaktivy, včetně používání Strategie, mohou vést ke ztrátě. Poskytovatel nenese odpovědnost za investiční ztráty, cenové pohyby trhu ani za ušlý zisk Klienta.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel neodpovídá za škody způsobené zejména výpadkem nebo omezením API Podporované platformy, změnou pravidel Podporované platformy, nedostupností internetu, chybou v nastavení API klíčů, nastavením jakýchkoliv parametrů v rámci Strategie, zásahem třetí osoby nebo jinými okolnostmi mimo přiměřenou kontrolu Poskytovatele.
              </p>
            </li>
            <li>
              <p>
                Aplikace je poskytována v režimu průběžně vyvíjené digitální služby. Poskytovatel usiluje o její dostupnost a bezpečnost, avšak negarantuje nepřetržitou dostupnost bez výpadků či chyb.
              </p>
            </li>
            <li>
              <p>
                Žádné informace v Aplikaci, na webu, v e-mailech, na sociálních sítích ani v marketingových materiálech Poskytovatele nepředstavují investiční poradenství, poskytování poradenství týkajícího se kryptoaktiv zahrnující doporučení k nákupu/prodeji kryptoaktiv, využití konkrétní služby související s kryptoaktivy nebo konkrétního poskytovatele služeb souvisejících s kryptoaktivy ani individuální právní či daňové poradenství.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel neomezuje ani nevylučuje odpovědnost v rozsahu, v jakém ji nelze podle právních předpisů vyloučit nebo omezit, zejména odpovědnost za újmu způsobenou úmyslně nebo z hrubé nedbalosti, je-li takové omezení právně nepřípustné.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Ochrana osobních údajů</p>
          <ol type="a">
            <li>
              <p>
                Poskytovatel zpracovává osobní údaje Klienta (zejména identifikační a kontaktní údaje, fakturační údaje, údaje o využívání Služby a platební historii) za účelem poskytování Služby, plnění smlouvy, plnění zákonných povinností a ochrany oprávněných zájmů Poskytovatele.
              </p>
            </li>
            <li>
              <p>
                Údaje o platebních kartách Poskytovatel nezpracovává; zpracování platebních karet zajišťují příslušní platební partneři (např. Stripe) podle vlastních podmínek a zásad ochrany osobních údajů.
              </p>
            </li>
            <li>
              <p>
                Přístupové údaje nezbytné pro fungování Služby jsou uchovávány odděleně a zabezpečeně (včetně šifrování), v rozsahu nezbytném pro poskytování Služby.
              </p>
            </li>
            <li>
              <p>
                Detailní informace o zpracování osobních údajů, včetně právních základů, příjemců/zpracovatelů, dob uchování, případného předávání do třetích zemí, práv Klienta a informací o cookies, jsou uvedeny v samostatném dokumentu Zásady ochrany osobních údajů na webu.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Změny Podmínek, změny Služby a ukončení</p>
          <ol type="a">
            <li>
              <p>
                Poskytovatel je oprávněn tyto Podmínky v přiměřeném rozsahu měnit, zejména z důvodu změny právních předpisů, technického vývoje Služby, změn obchodního modelu, bezpečnostních požadavků nebo změn na straně Podporovaných platforem či platebních partnerů.
              </p>
            </li>
            <li>
              <p>
                O podstatných změnách Podmínek bude Klient informován e-mailem a/nebo prostřednictvím Aplikace zpravidla předem. Pokud Klient se změnou nesouhlasí, může před nabytím účinnosti změny ukončit užívání Služby a zrušit svůj účet v Aplikaci.
              </p>
            </li>
            <li>
              <p>
                Poskytovatel je oprávněn ukončit nebo omezit poskytování Služby Klientovi, který porušuje tyto Podmínky, právní předpisy nebo bezpečnostní pravidla, a to po předchozím upozornění, je-li to s ohledem na okolnosti možné.
              </p>
            </li>
            <li>
              <p>
                Ustanovení těchto Podmínek, která mají podle své povahy trvat i po ukončení smluvního vztahu (zejména odpovědnost, reklamace, řešení sporů, ochrana osobních údajů a závěrečná ustanovení), zůstávají v platnosti i po ukončení užívání Služby.
              </p>
            </li>
          </ol>
        </li>
        <li>
          <p>Závěrečná ustanovení</p>
          <ol type="a">
            <li>
              <p>
                Právní vztahy mezi Poskytovatelem a Klientem se řídí právem České republiky. Tím nejsou dotčena kogentní ustanovení na ochranu Spotřebitele, která se použijí bez ohledu na tuto volbu práva, pokud jsou aplikovatelná.
              </p>
            </li>
            <li>
              <p>
                Dozor nad dodržováním povinností v oblasti ochrany spotřebitele vykonává Česká obchodní inspekce (ČOI), není-li právními předpisy stanoveno jinak.
              </p>
            </li>
            <li>
              <p>
                Pokud se některé ustanovení těchto Podmínek stane neplatným, neúčinným nebo nevymahatelným, nemá to vliv na platnost a účinnost ostatních ustanovení; namísto takového ustanovení se použije ustanovení právních předpisů, které svým smyslem a účelem nejlépe odpovídá zamýšlenému účelu.
              </p>
            </li>
            <li>
              <p>
                Tyto Podmínky jsou účinné od 29. 7. 2026.
              </p>
            </li>
            <li>
              <p>
                Jakékoliv dotazy, reklamace, podněty a požadavky ve vztahu ke Službě nebo ke zpracování osobních údajů lze zasílat na e-mailovou adresu: info@stosuj.cz
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </>
  );
};

export default TermsAndConditions;
